export enum InternalEventType {
    // SSE Test Events
    SSE_TEST_EVENT = 'sseTestEvent',

    // Initialization Events
    INIT = 'init',
    HEARTBEAT = 'heartbeat',

    // Candidate Events
    CANDIDATE_PROCESSED = 'candidateProcessed',
    CANDIDATE_DELETED = 'candidateDeleted',

    // Job Application Events
    JOB_APPLICATION_PROCESSED = 'jobApplicationProcessed',
    JOB_APPLICATION_DELETED = 'jobApplicationDeleted',
    JOB_APPLICATION_ERROR = 'jobApplicationError',

    // Job Posting Events
    JOB_POSTING_PROCESSED = 'jobPostingProcessed',
    JOB_POSTING_DELETED = 'jobPostingDeleted',

    // Screening Interview Events
    SCREENING_INTERVIEW_QUESTIONS_GENERATED = 'screeningInterviewQuestionsGenerated',
    SCREENING_INTERVIEW_UPDATED = 'screeningInterviewUpdated',

    // Human Interview (Panelist) Events
    HUMAN_INTERVIEW_QUESTIONS_GENERATED = 'humanInterviewQuestionsGenerated',
    HUMAN_INTERVIEW_UPDATED = 'humanInterviewUpdated',
    HUMAN_INTERVIEW_TRANSCRIPT_READY = 'humanInterviewTranscriptReady',

    // Marlee Orchestrator Events
    MARLEE_PLANNING = 'MarleePlanning',
    MARLEE_SEARCHING = 'MarleeSearching',
    MARLEE_PLAN_READY = 'MarleePlanReady',
    MARLEE_EXECUTING = 'MarleeExecuting',
    MARLEE_STEP_COMPLETED = 'MarleeStepCompleted',
    MARLEE_EXECUTION_COMPLETE = 'MarleeExecutionComplete',
}
